import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const StockListCommons = ({
  items,
  openStockReturn,
  openTransfer,
  stock,
  openRemove,
  returnOpen,
  removeOpen,
  transferOpen,
  setReturnOpen,
  setRemoveOpen,
  setTransferOpen,
  ReturnStock,
  TransferStock,
  hasEditPermissions,
  Filter,
  disableTransfer = false,
  RemoveStock,
  disableReturn = false,
}) => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Box>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box
            sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
            padding={1}
          >
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: 150 }}>
                      {isSmallScreen ? "Name" : "Product name"}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 120 }}>
                      Price
                    </TableCell>
                    <TableCell align="center">Qty</TableCell>
                    {hasEditPermissions && (
                      <>
                        <TableCell>&nbsp;</TableCell>
                        <TableCell>&nbsp;</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item) => (
                    <TableRow
                      key={item.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {item.name} {item.owner_name && `( ${item.owner_name} )`}
                      </TableCell>
                      <TableCell align="center">{item.price} Rs</TableCell>
                      <TableCell align="center">{item.qty} Nos</TableCell>
                      {hasEditPermissions && (
                        <>
                          {!disableReturn && (
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                size="small"
                                color="error"
                                sx={{ width: "13ch" }}
                                onClick={() => {
                                  openStockReturn(item);
                                }}
                                disabled={item.qty === 0}
                              >
                                Return item
                              </Button>
                            </TableCell>
                          )}
                          {RemoveStock && (
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                size="small"
                                color="error"
                                sx={{ width: "13ch" }}
                                onClick={() => {
                                  openRemove(item);
                                }}
                                disabled={item.qty === 0}
                              >
                                Discard item
                              </Button>
                            </TableCell>
                          )}
                          {!disableTransfer && (
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                size="small"
                                color="info"
                                sx={{ width: "12ch" }}
                                disabled={item.qty === 0}
                                onClick={() => {
                                  openTransfer(item);
                                }}
                              >
                                Transfer
                              </Button>
                            </TableCell>
                          )}
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      {stock && (
        <ReturnStock
          open={returnOpen}
          handleClose={() => setReturnOpen(false)}
          stock={stock}
        />
      )}
      {stock && RemoveStock && (
        <RemoveStock
          open={removeOpen}
          handleClose={() => setRemoveOpen(false)}
          stock={stock}
        />
      )}
      {stock && (
        <TransferStock
          open={transferOpen}
          handleClose={() => setTransferOpen(false)}
          stock={stock}
        />
      )}
    </Box>
  );
};

export default StockListCommons;
